<template>
	<div style="display: contents;">
		<template v-if="buttonComponent == 'v-btn'">
            <v-tooltip top>
                <template v-slot:activator="{ on: tooltip }">
                    <v-btn
                        v-on="{ ...tooltip }"
						:fab="button.params.fab ? button.params.fab : false"
						:icon="button.params.fab ? false : true"
						:small="button.params.small ? true : false"
						:fixed="button.params.fixed ? true : false"
						:bottom="button.params.bottom ? true : false"
						:right="button.params.right ? true : false"
						:dark="button.params.dark ? true : false"
						:color="button.params.button_color ? button.params.button_color : ''"
						@click="openDialog()">
                        <v-icon :size="$vuetify.breakpoint.smAndDown ? 28 : 24" :color="params ? params.color : ''">{{ button.params.icon ? button.params.icon : 'mdi-account-arrow-right' }}</v-icon>
					</v-btn>
				</template>
        		<span>{{ button.tooltip ? button.tooltip : 'Converti in Prospect' }}</span>
    		</v-tooltip>
		</template>

		<v-list-item v-else-if="buttonComponent == 'v-list-item'"
            dense
            :disabled="disabled"
            @click.stop="openDialog()"
            ripple>
            <v-list-item-icon>
                <v-icon style="font-size: 18px">{{ button.params.icon ? button.params.icon : 'mdi-account-arrow-right' }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
                <v-list-item-title>{{ button.tooltip ? button.tooltip : 'Converti in Prospect' }}</v-list-item-title>
            </v-list-item-content>
        </v-list-item>

        <v-dialog v-model="show" max-width="900" persistent class="round-card" scrollable>
            <v-card class="background-2 round-card">
                <v-card-title class="pa-3">
                    <p class="pl-2 pl-xl-3">Converti {{ $trans('lead') }} in {{ $trans('prospect') }}</p>
                    <v-spacer></v-spacer>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="px-1 pb-1">
                    <v-container v-if="show" fluid class="px-6 pt-6">
                        <div class="pt-2 body-2 pb-4">
                            Vuoi convertire questo {{ $trans('lead') }} in un {{ $trans('prospect') }}? Tutti i dati del {{ $trans('lead') }} saranno trasferiti al nuovo {{ $trans('prospect') }}.
                        </div>

                        <v-switch
                            v-model="transfer_relations"
                            persistent-hint
                            :hint="`Se attivo trasferisce contatti, opportunità e preventivi collegati al ${$trans('lead')}`"
                            inset
                            :label="`Trasferisci Relazioni`"
                        ></v-switch>

                        <v-switch
                            v-if="canTransferContacts"
                            v-model="transfer_contacts"
                            persistent-hint
                            :hint="`Trasferisce tutti i contatti associati al ${$trans('lead')}`"
                            inset
                            :label="`Trasferisci Contatti`"
                            :disabled="!transfer_relations"
                        ></v-switch>

                        <v-switch
                            v-if="canTransferOpportunities"
                            v-model="transfer_opportunities"
                            persistent-hint
                            :hint="`Trasferisce tutte le opportunità associate al ${$trans('lead')}`"
                            inset
                            :label="`Trasferisci Opportunità`"
                            :disabled="!transfer_relations"
                        ></v-switch>

                        <v-switch
                            v-if="canTransferQuotations"
                            v-model="transfer_quotations"
                            persistent-hint
                            :hint="`Trasferisce tutti i preventivi associati al ${$trans('lead')}`"
                            inset
                            :label="`Trasferisci Preventivi`"
                            :disabled="!transfer_relations"
                        ></v-switch>

                        <v-switch
                            v-model="delete_lead"
                            persistent-hint
                            :hint="`Se attivo il ${$trans('lead')} viene eliminato e resta solo il ${$trans('prospect')}`"
                            inset
                            :label="`Elimina ${$trans('lead')}`"
                            color="warning"
                        ></v-switch>

                        <v-alert
                            v-if="!delete_lead"
                            type="warning"
                            dense
                            outlined
                            class="mt-4"
                        >
                            <strong>Attenzione:</strong> senza questa opzione restano aperte due schede della stessa anagrafica, il {{ $trans('lead') }} e il {{ $trans('prospect') }}.
                        </v-alert>
                    </v-container>

                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="info" @click.native.stop="closeDialog()">Annulla
                    </v-btn>
                    <v-btn
                        text
                        color="success"
                        @click.native.stop="convertLead()"
                        :loading="loading"
                        :disabled="!isValid"
                    >
                        Converti
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>

    export default {
        name: 'convert-lead-to-prospect-component',
        components: {
        },
        props: {
            button: Object,
            buttonComponent: {type: String, default : 'v-btn'},
            id: Number,
            model: Object,
            modelDef: String,
            params: Object,
            disabled: Boolean
        },

        data() {
            return {
                show: false,
                loading: false,
                transfer_relations: true,
                transfer_contacts: true,
                transfer_opportunities: true,
                transfer_quotations: true,
                delete_lead: true
            }
        },

        computed: {
            isValid() {
                return true
            },
            canTransferContacts() {
                return this.$store.getters.checkModelPermissions('companycontact')
            },
            canTransferOpportunities() {
                return this.$store.getters.checkModulePermissions('opportunities')
            },
            canTransferQuotations() {
                return this.$store.getters.checkModulePermissions('quotations')
            }
        },

        watch: {
            transfer_relations(newVal) {
                if (!newVal) {
                    this.transfer_contacts = false
                    this.transfer_opportunities = false
                    this.transfer_quotations = false
                }
            }
        },

        methods: {

            closeDialog() {
                this.show = false
                this.resetForm()
            },

            openDialog() {
                this.show = true
                this.resetForm()
            },

            resetForm() {
                this.transfer_relations = true
                this.transfer_contacts = this.canTransferContacts
                this.transfer_opportunities = this.canTransferOpportunities
                this.transfer_quotations = this.canTransferQuotations
                this.delete_lead = true
            },

            convertLead() {
                if (!this.isValid) {
                    return
                }

                let objectData = {
                    'transfer_relations': this.transfer_relations,
                    'transfer_contacts': this.transfer_contacts && this.transfer_relations,
                    'transfer_opportunities': this.transfer_opportunities && this.transfer_relations,
                    'transfer_quotations': this.transfer_quotations && this.transfer_relations,
                    'delete_lead': this.delete_lead
                }

                this.loading = true
                this.axios.post('leads-convert-to-prospect/' + this.id, objectData).then(response => {
                    this.$store.commit('setSnackbar', {
                        timeout: 6000,
                        text: response.data.message || 'Lead convertito in prospect con successo',
                        value: true,
                        color: 'success'
                    })

                    this.loading = false
                    this.closeDialog()

                    // Redirect to the new prospect
                    if (response.data.prospect_id) {
                        this.$eventBusUtility.goTo(this.$router, 'prospects-show', response.data.prospect_id)
                    } else {
                        // Refresh the leads list
                        this.$eventBusUtility.$emit('refreshTable_leads')
                    }

                }, response => {
                    this.loading = false
                    this.$store.commit('setSnackbar', {
                        timeout: 6000,
                        text: response.data?.message || 'Errore durante la conversione del lead',
                        value: true,
                        color: 'error'
                    })
                })
            }

        },
    }
</script>
